import {
	IconButton,
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	MimaTextArea,
	Modal,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { amountFormatter } from '../../utils/utils';
import { Field, FieldArray, Formik } from 'formik';
import constant from '../../utils/constant';
import moment from 'moment';
import { toJS } from 'mobx';
import React from 'react';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const FieldSelect = ({ field, ...props }) => {
	return <MimaDropdown {...field} {...props} />;
};

const EmployeePayDetails = ({
	closeModal,
	payroll,
	totalExtra,
	addFundList,
	loading,
	onSubmit,
	validationSchema,
	addDeductionList,
	editState,
	goToEditState,
	goToRequestChangeState,
	requestChange,
	requestChangeValidationSchema,
	onRequestChangeSubmit,
	goBack,
}) => {
	const employeeName = `${payroll.user?.firstname} ${payroll.user?.lastname}`;
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<div className={styles.gp}>
				{!editState && !requestChange && (
					<div className={styles.ps}>
						<MimaText
							variant="bodyBold"
							align="center"
							mb={4}
							width={38}
							color="var(--color-primary)"
						>
							{`${employeeName} ${moment(payroll.payDay).format('Do MMMM, YYYY')} Pay Details`}
						</MimaText>

						<MimaText labelTitle="Name" mb={2}>
							{`${payroll.user.firstname} ${payroll.user.lastname}`}{' '}
						</MimaText>
						<MimaText labelTitle="Initial Gross Salary" mb={2}>
							{amountFormatter().format(payroll.initialGross || 0)}
						</MimaText>


						<MimaText labelTitle="Gross Salary" mb={2}>
							{amountFormatter().format(payroll.grossPay || 0)}
						</MimaText>
						<MimaText labelTitle="Net Salary" mb={2}>
							{amountFormatter().format(payroll.netPay || 0)}
						</MimaText>
						<MimaText labelTitle="PAYE Tax" mb={2}>
							-{amountFormatter().format(payroll.tax || 0)}
						</MimaText>
						<MimaText labelTitle="WHT" mb={2}>
							-{amountFormatter().format(payroll.wht || 0)}
						</MimaText>
						<MimaText labelTitle="Pension" mb={2}>
							-{amountFormatter().format(payroll.pension || 0)}
						</MimaText>
						<MimaText labelTitle="NHF" mb={2}>
							-{amountFormatter().format(payroll.nhf || 0)}
						</MimaText>
						{payroll.payDeductions.map((pay, i) => (
							<MimaText labelTitle={pay.type} mb={2} key={i}>
								{`-${amountFormatter().format(pay.amount || 0)}`}
							</MimaText>
						))}
						<MimaText labelTitle="Other Deductions" mb={2}>
							-{amountFormatter().format(payroll.otherDeductionAmount || 0)}
						</MimaText>
						{payroll.payAdditions.map((pay, i) => (
							<MimaText labelTitle={pay.type} mb={2} key={i}>
								{amountFormatter().format(pay.amount || 0)}
							</MimaText>
						))}
						<MimaText labelTitle="Status" mb={2}>
							{payroll.status}
						</MimaText>
						<MimaText labelTitle="Approved Date" mb={2}>
							{payroll.approvedDate
								? moment(payroll.approvedDate).format('Do MMMM, YYYY')
								: ''}
						</MimaText>
						<MimaText labelTitle="Paid Date" mb={2}>
							{payroll.actualPaidDate
								? moment(payroll.actualPaidDate).format('Do MMMM, YYYY')
								: ''}
						</MimaText>

						<MimaText variant="small" color='var(--color-primary)' mb={1}> Comments </MimaText>
						 {toJS(payroll?.comments)?.sort((a,b)=> new Date(a.date) - new Date(b.date))?.map((item, i)=>(
							<div key={i} style={{width: "38rem", marginBottom: "2rem"}}>
								<MimaText>{`${item?.user?.firstname || ''} ${item?.user?.lastname || ''}`}</MimaText>
								<MimaText>{item.text}</MimaText>
								<MimaText variant="small" color='var(--color-error)' mt={-0.5}>{moment(item.date).format('Do MMMM, YYYY')}</MimaText>
							</div>
						))|| ''}

						{payroll.status === constant.STATUS.PENDING ||
						payroll.status === constant.STATUS.IN_REVIEW ||
						payroll.status === constant.STATUS.REVIEWED ||
						payroll.status === constant.STATUS.IGNORE ||
						payroll.status === constant.STATUS.REQUEST_CHANGE ? (
							<>
								<MimaButton
									buttonColor="var(--color-dark-2)"
									title="Update"
									variant="colorable"
									onClick={goToEditState}
									mb={2}
								/>
								<MimaButton
									title="Request Change"
									onClick={goToRequestChangeState}
								/>
							</>
						) : (
							''
						)}
					</div>
				)}

				{editState && !requestChange && (
					<>
						<Formik
							initialValues={{
								payDeductions: toJS(payroll.payDeductions) || [],
								payAdditions: toJS(payroll.payAdditions) || [],
							}}
							validationSchema={validationSchema()}
							onSubmit={onSubmit}
						>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									{values.payDeductions.length ? (
										<MimaText
											mt={2}
											mb={2}
											align="center"
											color="var(--color-primary)"
											variant="bodyBold"
										>
											Deductions
										</MimaText>
									) : (
										''
									)}
									<FieldArray name="payDeductions">
										{({ push, remove }) => (
											<React.Fragment>
												{values.payDeductions?.length
													? values?.payDeductions.map((item, i) => (
															<div key={i}>
																<Field
																	as="select"
																	component={FieldSelect}
																	name={`payDeductions.${i}.type`}
																	value={values.payDeductions[i].type}
																	onChange={e => {
																		setFieldValue(
																			`payDeductions.${i}.type`,
																			e.value
																		);
																	}}
																	placeholder={
																		values.payDeductions[i].type ||
																		'Select Deduction type'
																	}
																	data={addDeductionList.map(item => ({
																		key: item,
																		value: item,
																	}))}
																	labelTitle="Deduction Type"
																/>

																<Field
																	name={`payDeductions.${i}.amount`}
																	type="number"
																	component={FieldInput}
																	labelTitle="Deduction Amount"
																	min="0"
																/>

																{i >= 0 ? (
																	<IconButton
																		variant="remove"
																		onClick={() => remove(i)}
																	/>
																) : (
																	''
																)}
																<div
																	className={styles.employee__list_line}
																></div>
															</div>
													  ))
													: ''}
												<MimaButton
													title={`Add ${
														values.payDeductions.length > 0 ? 'Another' : ''
													} Deduction`}
													onClick={() =>
														push({
															amount: 0,
															type: '',
														})
													}
													variant="filter"
													mt={2}
												/>
												<MimaText
													mt={3}
													align="center"
													color="var(--color-error)"
												>
													{`${totalExtra(
														values.payDeductions
													)} would be deducted
													`}
												</MimaText>

											</React.Fragment>
										)}
									</FieldArray>
									{values.payAdditions.length && values.payAdditions.length ? (
										<MimaText
											mt={5}
											mb={2}
											align="center"
											color="var(--color-primary)"
											variant="bodyBold"
										>
											Additions
										</MimaText>
									) : (
										''
									)}
									<FieldArray name="payAdditions">
										{({ push, remove }) => (
											<React.Fragment>
												{values.payAdditions.map((_, i) => (
													<div key={i}>

															<Field
																as="select"
																component={FieldSelect}
																name={`payAdditions.${i}.type`}
																value={values.payAdditions[i].type}
																onChange={e => {
																	setFieldValue(
																		`payAdditions.${i}.type`,
																		e.value
																	);
																}}
																placeholder={
																	values.payAdditions[i].type ||
																	'Select Addition type'
																}
																data={addFundList.map(item => ({
																	key: item,
																	value: item,
																}))}
																labelTitle="Addition Type"
															>
																{/* <MenuItem value=""></MenuItem>
																{addFundList.map((fund, key) => (
																	<MenuItem key={key} value={fund}>
																		{fund}
																	</MenuItem>
																))} */}
															</Field>
															<Field
																name={`payAdditions.${i}.amount`}
																type="number"
																component={FieldInput}
																labelTitle="Addition Amount"
																min="0"
															/>

															{i >= 0 ? (
																<IconButton
																	variant="remove"
																	onClick={() => remove(i)}
																/>
															) : (
																''
															)}
															<div className={styles.employee__list_line}> </div>

													</div>
												))}

												<MimaButton
													title={`Add ${
														values.payAdditions.length > 0 ? 'Another' : ''
													} Fund`}
													type="button"
													onClick={() =>
														push({
															amount: 0,
															type: '',
														})
													}
													variant="filter"
													mt={2}
												/>
												<MimaText mt={2} align="center">
													{`${totalExtra(values.payAdditions)} would be added
													`}
												</MimaText>
											</React.Fragment>
										)}
									</FieldArray>

									<MimaButton
										disabled={loading}
										loading={loading}
										title="Save"
										type="submit"
										onClick={handleSubmit}
										mt={5}
									/>
								</div>
							)}
						</Formik>
					</>
				)}
				{requestChange && (
					<>
						<Formik
							initialValues={{
								comment: '',
								employeeName: employeeName,
							}}
							validationSchema={requestChangeValidationSchema}
							onSubmit={onRequestChangeSubmit}
						>
							{({
								handleSubmit,
								handleChange,
								handleBlur,
								values,
								errors,
								touched,
							}) => (
								<>
									<MimaText labelTitle="Name" mb={2}>
										{`Employee Name: ${employeeName}`}
									</MimaText>

									<MimaTextArea
										type="textarea"
										labelTitle="Comment"
										placeholder="Enter Comment"
										name="comment"
										mb={2}
										variant="message"
										error={errors.comment}
										touched={touched.comment}
										value={values.comment}
										onChange={handleChange}
										onBlur={handleBlur}
									/>
									<MimaButton
										title="Request Change"
										onClick={handleSubmit}
										type="submit"
										loading={loading}
										mt={2}
									/>
								</>
							)}
						</Formik>
					</>
				)}
			</div>
		</Modal>
	);
};

export default EmployeePayDetails;
